import { all, fork } from "redux-saga/effects";
import { currentUserWatcher, usersWatcher } from "src/modules/users/saga";
import { initDataWatcher } from "src/modules/initData/sagas";
import { itemsWatcher } from "../modules/spItems/sagas";
import { searchPeopleWatcher } from "src/components/ui/form/peoplePicker/sagas";
import { workDocumentsInfoWatcher } from "src/modules/acadia/documents/sagas";
import { notificationsInfoWatcher } from "src/modules/acadia/notifications/sagas";
import { vpoWatcher } from "src/modules/vpo/sagas";
import { vpoWatcherStrapi } from "src/pages/DashboardPage/vpo/sagas/sagas";
import { gosWatcher } from "src/modules/gos/sagas";
import { gopWatcher } from "src/pages/DashboardPage/gop/sagas/sagas";
import { checklistTasksWatcher } from "src/modules/checklistTasks/sagas";
import { gosWatcherStrapi } from "src/pages/DashboardPage/gos/sagas/sagas";
import { changeApproversWatcher } from "src/modules/changeApprovers/sagas";
import { myTasksWatcherStrapi } from "src/pages/DashboardPage/mytasks/sagas/sagas";


function* acadiaRootWatcher() {
  yield all([
    fork(workDocumentsInfoWatcher),
    fork(initDataWatcher),
    fork(notificationsInfoWatcher)
  ]);
}

function* rootSaga() {
  yield fork(currentUserWatcher);
  yield fork(usersWatcher);
  yield fork(itemsWatcher);
  yield fork(searchPeopleWatcher);

  yield fork(acadiaRootWatcher);

  yield fork(vpoWatcher);
  yield fork(vpoWatcherStrapi);
  yield fork(gosWatcher);

  yield fork(gopWatcher);
  yield fork(checklistTasksWatcher);
  yield fork(gosWatcherStrapi);
  
  yield fork(changeApproversWatcher);
  yield fork(myTasksWatcherStrapi);
}

export default rootSaga;
